import { Injectable } from '@angular/core'
import { HttpService, LibEntry } from '@surgetech-eu/core'
import { Observable } from 'rxjs'

export interface MaterialDetails {
    key: string
    description?: string
    mandatoryCertificates?: LibEntry[]
    disabled?: boolean
    createdAt?: Date
    new?: boolean
    id?: string
    rank?: number
    used?: boolean
}

@Injectable()
export class MaterialDetailsService {
    constructor(private http: HttpService) {}

    getAll(): Observable<MaterialDetails[]> {
        return this.http.get<MaterialDetails[]>(`/handbook/management/material-details`)
    }

    remove(key: string): Observable<void> {
        return this.http.delete(`/handbook/management/material-details/${key}`)
    }

    createOrUpdate(data: MaterialDetails[]): Observable<void> {
        return this.http.patch(`/handbook/management/material-details`, { data })
    }
}
